import { useEffect, useState } from 'react';

interface LoadingMangoProps {
  isVisible: boolean;
}

export default function LoadingMango({ isVisible }: LoadingMangoProps): JSX.Element | null {
  const [show, setShow] = useState(isVisible);

  useEffect(() => {
    if (isVisible) {
      setShow(true);
      return;
    }

    const timer = window.setTimeout(() => setShow(false), 200);
    return () => window.clearTimeout(timer);
  }, [isVisible]);

  if (!show) {
    return null;
  }

  return (
    <div className={`mango-loader ${isVisible ? 'mango-loader--visible' : ''}`} role="status" aria-live="polite">
      <div className="mango-loader__card">
        <div className="mango-orbit">
          <span className="mango-orbit__ring" aria-hidden="true" />
          <div className="mango-runner">
            <div className="mango-upright">
              <div className="mango-bounce">
                <img
                  className="mango-image"
                  src="/cute-mango.jpg"
                  alt=""
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        </div>
        <p className="mango-loader__text">
          Loading
          <span className="mango-loader__dots">...</span>
        </p>
        <span className="sr-only">Page loading</span>
      </div>
    </div>
  );
}
